import { render, staticRenderFns } from "./SmallLoader.vue?vue&type=template&id=f58bffd6&scoped=true&"
import script from "./SmallLoader.vue?vue&type=script&lang=ts&"
export * from "./SmallLoader.vue?vue&type=script&lang=ts&"
import style0 from "./SmallLoader.vue?vue&type=style&index=0&id=f58bffd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58bffd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/cypher.team.viz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f58bffd6')) {
      api.createRecord('f58bffd6', component.options)
    } else {
      api.reload('f58bffd6', component.options)
    }
    module.hot.accept("./SmallLoader.vue?vue&type=template&id=f58bffd6&scoped=true&", function () {
      api.rerender('f58bffd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LossModal/SmallLoader.vue"
export default component.exports